import { render, staticRenderFns } from "./group-mutrules.vue?vue&type=template&id=8af5d2ec&scoped=true&"
import script from "./group-mutrules.vue?vue&type=script&lang=js&"
export * from "./group-mutrules.vue?vue&type=script&lang=js&"
import style0 from "./group-mutrules.vue?vue&type=style&index=0&id=8af5d2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af5d2ec",
  null
  
)

export default component.exports